import React from 'react';
import logo from '../assets/laftek.png';
import { buildApplyUrl, services } from '../data';
import './Footer.css';

export default function Footer() {
  return (
    <footer>
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="footer-logo">
            <img src={logo} alt="Laftek Business Solutions" className="footer-logo-image" />
          </div>
          <p>Laftek Business Solutions helps candidates build their careers with placement support, training, counseling, and ongoing guidance.</p>
          <div className="footer-socials">
            <a href="https://www.youtube.com/@KKConsultingblr" target="_blank" rel="noreferrer" className="social-btn" aria-label="YouTube">
              <svg viewBox="0 0 24 24" className="social-icon" aria-hidden="true">
                <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.6 3.6 12 3.6 12 3.6s-7.6 0-9.4.5A3 3 0 0 0 .5 6.2 31.3 31.3 0 0 0 0 12a31.3 31.3 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.8.5 9.4.5 9.4.5s7.6 0 9.4-.5a3 3 0 0 0 2.1-2.1A31.3 31.3 0 0 0 24 12a31.3 31.3 0 0 0-.5-5.8ZM9.6 15.7V8.3L16 12l-6.4 3.7Z" fill="currentColor"/>
              </svg>
            </a>
            <a href="https://wa.me/917880788799" target="_blank" rel="noreferrer" className="social-btn" aria-label="WhatsApp">
              <svg viewBox="0 0 24 24" className="social-icon" aria-hidden="true">
                <path d="M20 3.9A11.8 11.8 0 0 0 1.9 18.1L.7 23.3l5.4-1.2A11.8 11.8 0 1 0 20 3.9Zm-8 16a9.7 9.7 0 0 1-4.9-1.3l-.3-.2-3.2.7.7-3.1-.2-.3A9.8 9.8 0 1 1 12 19.9Zm5.4-7.3c-.3-.2-1.8-.9-2-1-.3-.1-.5-.2-.7.2l-.8 1c-.1.2-.3.2-.6.1a8 8 0 0 1-2.3-1.4 8.8 8.8 0 0 1-1.6-2c-.2-.3 0-.4.1-.6l.5-.6.3-.5a.6.6 0 0 0 0-.6l-1-2.3c-.2-.4-.4-.4-.6-.4h-.5a1 1 0 0 0-.8.4 3.2 3.2 0 0 0-1 2.4c0 1.4 1 2.7 1.2 2.8.1.2 2 3 4.8 4.2.7.3 1.2.5 1.7.7.7.2 1.4.2 1.9.1.6-.1 1.8-.8 2-1.6.3-.8.3-1.5.2-1.6 0-.2-.2-.2-.5-.4Z" fill="currentColor"/>
              </svg>
            </a>
            <a href="mailto:support@laftekbusinesssolutions.co.in" className="social-btn" aria-label="Email">
              <svg viewBox="0 0 24 24" className="social-icon" aria-hidden="true">
                <path d="M3 5.5A2.5 2.5 0 0 1 5.5 3h13A2.5 2.5 0 0 1 21 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18.5v-13Zm2.2.5 6.8 5.5 6.8-5.5H5.2Zm13.8 2.3-6.4 5.1a1 1 0 0 1-1.2 0L5 8.3v10.2c0 .3.2.5.5.5h13c.3 0 .5-.2.5-.5V8.3Z" fill="currentColor"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            {services.map((service) => (
              <li key={service.num}><a href="/services">{service.title}</a></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <div className="footer-contact-list">
            <a className="footer-contact-item" href="tel:+917880788799">
              <span>Phone</span>
              +91 7880 788 799
            </a>
            <a className="footer-contact-item" href="mailto:support@laftekbusinesssolutions.co.in">
              <span>Email</span>
              support@laftekbusinesssolutions.co.in
            </a>
          </div>

          <div className="footer-actions">
            <a href="/ai-careers">AI & Careers</a>
            <a href={buildApplyUrl()}>Apply Now</a>
          </div>

          <div className="footer-address">
            <span>Office Address</span>
            <p>
              Kodi, 7th Floor, BetaBlock,<br />
              Sigma Soft Tech Park, Whitefield Main Road, Varthur,<br />
              Bengaluru, Karnataka 560037
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>Copyright 2025 Laftek Business Solutions. All rights reserved.</span>
        <span>Built for career builders</span>
      </div>
    </footer>
  );
}
